import classNames from 'classnames'
import React, { Component } from 'react'
import ReactClickOutside from '../lib/react-click-outside'
import R from '../ramda'
import './YearFilter.css'

class YearFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // selezione interattiva corrente, dal primo elemento selezionato
      // all'ultimo (potrebbe essere in ordine crescente o decrescente)
      // null se non c'è una selezione in corso
      selecting: null,
    }
  }

  // ------------------------------------------ HANDLERS ------------------------------------------

  selectNone() {
    const { onChange } = this.props

    onChange([null, null])

    this.setState({
      selecting: null,
    })
  }

  selectStart(year) {
    this.setState({
      selecting: [year, year],
    })
  }

  selectTo(year) {
    this.setState(
      (prevState) =>
        prevState.selecting && {
          selecting: [prevState.selecting[0], year],
        },
    )
  }

  selectDone() {
    const { onChange } = this.props
    const { selecting } = this.state

    if (!selecting) return

    onChange(R.sort((x, y) => x - y, selecting))

    this.setState({
      selecting: null,
    })
  }

  // onMouseUp esterno a questo componente
  handleClickOutside() {
    this.selectDone()
  }

  selectCancel() {
    this.setState({
      selecting: null,
    })
  }

  // ------------------------------------------ UTILITY -------------------------------------------

  yearFromTouchEvent(event) {
    const touch = event.changedTouches[0]
    if (!touch) return null
    const elem = document.elementFromPoint(touch.clientX, touch.clientY)
    if (!elem) return null
    return elem.getAttribute('data-year')
  }

  // ------------------------------------------- RENDER -------------------------------------------

  render() {
    const { value, yearBounds } = this.props
    const { selecting } = this.state

    if (!yearBounds) {
      return null
    }

    const [filter_from, filter_to] = value
    const { first_year, last_is_partial, last_full_year } = yearBounds

    let from, to
    if (selecting) {
      [from, to] = R.sort((x, y) => x - y, selecting)
    } else if (filter_from && filter_to) {
      from = filter_from
      to = filter_to
    } else if (last_is_partial) {
      from = to = null
    } else {
      from = to = last_full_year
    }

    return (
      <div className="YearFilter" onMouseUp={() => this.selectDone()}>
        <label>Seleziona uno o più anni:</label>
        <div>
          {R.range(first_year, last_full_year + 1).map((year) => {
            const in_range = from && to && year >= from && year <= to
            return (
              <button
                key={year}
                className={classNames({
                  year: true,
                  selecting: selecting && in_range,
                  selected: !selecting && in_range,
                })}
                data-year={year}
                onMouseDown={() => this.selectStart(year)}
                onMouseEnter={() => this.selectTo(year)}
                style={{
                  // disattivo scroll tramite touch
                  touchAction: 'none',
                }}
                onTouchStart={(ev) => {
                  const year = this.yearFromTouchEvent(ev)
                  if (year) this.selectStart(year)
                }}
                onTouchMove={(ev) => {
                  const year = this.yearFromTouchEvent(ev)
                  if (year) this.selectTo(year)
                }}
                onTouchEnd={() => this.selectDone()}
                onTouchCancel={() => this.selectCancel()}
              >
                {year}
              </button>
            )
          })}
          {!!last_is_partial && (
            <button
              key="cur"
              className={classNames({
                year: true,
                full: true,
                selected: !from || !to,
              })}
              onClick={() => this.selectNone()}
            >
              Anno in corso
            </button>
          )}
        </div>
      </div>
    )
  }
}

export default ReactClickOutside({ event: 'mouseup' })(YearFilter)



// WEBPACK FOOTER //
// ./src/filters/YearFilter.js